import { YoYEmission } from 'models/MainDashboard/yoyModel.model';
import { serializable, list, object, primitive, alias } from 'serializr';

class SbtiTargetListItem {
  @serializable(alias('target_name', primitive()))
  targetName?: string;
}

class SbtiDashboardResponse {
  @serializable(alias('yoy_emission', list(object(YoYEmission))))
  yoyEmission?: YoYEmission[];

  @serializable(alias('sbti_targets', list(object(SbtiTargetListItem))))
  sbtiTargetList?: SbtiTargetListItem[];
}

export { YoYEmission, SbtiTargetListItem, SbtiDashboardResponse };
